export const translations = {
  en: {
    appName: "FleetOil Tracker",
    tagline: "Kilometer & oil-change tracking for your rental fleet",
    signInGoogle: "Sign in with Google",
    dashboard: "Dashboard",
    cars: "Cars",
    trips: "Returns",
    reports: "Reports",
    logout: "Log out",
    language: "Language",
    english: "English",
    arabic: "العربية",
    totalCars: "Total cars",
    totalReturns: "Total returns",
    healthy: "Healthy",
    warning: "Approaching",
    urgent: "Urgent",
    alerts: "Oil change alerts",
    noAlerts: "All cars are within safe range.",
    addCar: "Add car",
    editCar: "Edit car",
    deleteCar: "Delete car",
    plateNumber: "Plate number",
    make: "Make",
    model: "Model",
    year: "Year",
    color: "Color",
    currentKm: "Current km",
    lastOilKm: "Last oil-change km",
    intervalKm: "Oil change interval (km)",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    logReturn: "Log return",
    returnKm: "Return kilometers",
    renterName: "Renter name",
    date: "Date",
    kmDriven: "Km driven",
    remainingKm: "Km until oil change",
    status: "Status",
    actions: "Actions",
    history: "History",
    viewDetails: "View details",
    recordOilChange: "Record oil change",
    oilChangeAtKm: "Oil change at km",
    exportPdf: "Print PDF",
    exportExcel: "Export Excel",
    printReceipt: "Print receipt",
    empty: "No data yet",
    confirmDelete: "Are you sure? This will remove the car and its history.",
    signInHeadline: "Track every kilometer.",
    signInSub: "Sign in to manage your rental fleet and never miss an oil change.",
    invalidReturnKm: "Return km must be greater than or equal to current km.",
    createdCar: "Car added",
    updatedCar: "Car updated",
    deletedCar: "Car removed",
    createdTrip: "Return logged",
    createdOil: "Oil change recorded",
    fleetOverview: "Fleet overview",
    quickReturn: "Quick return log",
    selectCar: "Select a car",
    all: "All",
    upcoming: "Upcoming service",
    intervalHint: "e.g. 5000",
    maintenance: "Maintenance",
    remaining: "Remaining",
    over: "Overdue by",
    km: "km",
    signedInAs: "Signed in as",
    loginTitle: "Sign in",
    signIn: "Sign in",
    username: "Username",
    password: "Password",
    newPassword: "New password",
    changePassword: "Change password",
    loginFailed: "Sign-in failed",
    contactAdmin: "No account? Contact us to subscribe on the number below.",
    subscribeCta: "To subscribe, contact us on:",
    contactPhone: "+968 9380 3727",
    accounts: "Accounts",
    createAccount: "Create account",
    createAccountDesc: "New office account with subscription period",
    deleteUser: "Delete account",
    confirmDeleteUser: "This removes the office account and all their cars, trips, and history.",
    deletedUser: "Account deleted",
    accountCreated: "Account created",
    periodExtended: "Period extended",
    passwordUpdated: "Password updated",
    periodValue: "Duration",
    periodUnit: "Unit",
    months: "Months",
    years: "Years",
    role: "Role",
    roleAdmin: "Admin",
    roleOffice: "Office",
    expires: "Expires",
    noExpiry: "No expiry",
    expired: "Expired",
    daysLeft: "days left",
    statusCol: "Status",
    disable: "Disable",
    enable: "Enable",
    disabled: "Disabled",
    extendPeriod: "Extend subscription",
    lastOilDate: "Last oil-change date",
    gpsSection: "GPS tracking",
    gpsDeviceId: "MadarTech Device ID",
    gpsDeviceHint: "Enter the device identifier from your MadarTech account",
    gpsSync: "Sync GPS now",
    gpsSyncing: "Syncing…",
    gpsSynced: "GPS synced",
    gpsSyncFailed: "GPS sync failed",
    gpsNotConfigured: "GPS integration is not configured on the server",
    gpsNoDevice: "No GPS device is linked to this car",
    gpsLastSync: "Last sync",
    gpsPosition: "Last position",
    gpsOdometer: "GPS odometer",
    viewOnMap: "View on map",
    emailLabel: "Email",
    emailHint: "Daily digest will be sent at 23:55 Oman time",
    emailCol: "Email",
    settings: "Settings",
    filterByCar: "Filter by car",
    tripHistory: "Return history",
    noTrips: "No returns logged yet.",
    firstTimeCta: "Add your first car to start tracking.",
    close: "Close",
    settingsPage: "Settings",
    officeSection: "Rental office branding",
    officeName: "Office name",
    officeNameHint: "Shown in the sidebar and reports",
    officeLogo: "Office logo",
    uploadLogo: "Upload logo",
    removeLogo: "Remove logo",
    logoHint: "Square PNG or JPG, max 500KB",
    themeSection: "Theme color",
    themeDesc: "Pick the accent color used on primary buttons, links, and status indicators.",
    themeColor: "Preferred color",
    presetColors: "Presets",
    resetTheme: "Reset to default",
    savedSettings: "Settings saved",
    logoTooLarge: "Image is too large. Please choose a file under 500KB.",
    footerRights: "All rights reserved to Engineer Sultan Abdulaziz Aboudheba",
  },
  ar: {
    appName: "متتبع الأسطول",
    tagline: "حساب الكيلومترات وتبديل الزيت لسيارات التأجير",
    signInGoogle: "تسجيل الدخول بجوجل",
    dashboard: "لوحة التحكم",
    cars: "السيارات",
    trips: "الإرجاعات",
    reports: "التقارير",
    logout: "تسجيل الخروج",
    language: "اللغة",
    english: "English",
    arabic: "العربية",
    totalCars: "إجمالي السيارات",
    totalReturns: "إجمالي الإرجاعات",
    healthy: "بحالة جيدة",
    warning: "قريبة من الصيانة",
    urgent: "عاجلة",
    alerts: "تنبيهات تبديل الزيت",
    noAlerts: "كل السيارات ضمن الحدود الآمنة.",
    addCar: "إضافة سيارة",
    editCar: "تعديل السيارة",
    deleteCar: "حذف السيارة",
    plateNumber: "رقم اللوحة",
    make: "الصانع",
    model: "الموديل",
    year: "السنة",
    color: "اللون",
    currentKm: "الكيلومتر الحالي",
    lastOilKm: "كيلومتر آخر تبديل زيت",
    intervalKm: "الفاصل بين تبديل الزيت (كم)",
    notes: "ملاحظات",
    save: "حفظ",
    cancel: "إلغاء",
    logReturn: "تسجيل إرجاع",
    returnKm: "كيلومتر الإرجاع",
    renterName: "اسم المستأجر",
    date: "التاريخ",
    kmDriven: "الكيلومترات المقطوعة",
    remainingKm: "المتبقي حتى تبديل الزيت",
    status: "الحالة",
    actions: "إجراءات",
    history: "السجل",
    viewDetails: "التفاصيل",
    recordOilChange: "تسجيل تبديل زيت",
    oilChangeAtKm: "تم التبديل عند كم",
    exportPdf: "طباعة PDF",
    exportExcel: "تصدير Excel",
    printReceipt: "طباعة إيصال",
    empty: "لا توجد بيانات",
    confirmDelete: "هل أنت متأكد؟ سيتم حذف السيارة وكل سجلاتها.",
    signInHeadline: "تتبّع كل كيلومتر.",
    signInSub: "سجّل دخولك لإدارة أسطول التأجير ولا تفوت أي تبديل زيت.",
    invalidReturnKm: "يجب أن يكون كيلومتر الإرجاع أكبر أو يساوي الكيلومتر الحالي.",
    createdCar: "تمت إضافة السيارة",
    updatedCar: "تم تحديث السيارة",
    deletedCar: "تم حذف السيارة",
    createdTrip: "تم تسجيل الإرجاع",
    createdOil: "تم تسجيل تبديل الزيت",
    fleetOverview: "نظرة عامة على الأسطول",
    quickReturn: "تسجيل إرجاع سريع",
    selectCar: "اختر سيارة",
    all: "الكل",
    upcoming: "الصيانة القادمة",
    intervalHint: "مثال: 5000",
    maintenance: "الصيانة",
    remaining: "المتبقي",
    over: "متأخر بمقدار",
    km: "كم",
    signedInAs: "مسجّل الدخول باسم",
    loginTitle: "تسجيل الدخول",
    signIn: "دخول",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    newPassword: "كلمة المرور الجديدة",
    changePassword: "تغيير كلمة المرور",
    loginFailed: "فشل تسجيل الدخول",
    contactAdmin: "لا تملك حساباً؟ تواصل معنا للاشتراك على الرقم أدناه.",
    subscribeCta: "للاشتراك تواصل بنا على الرقم التالي:",
    contactPhone: "+968 9380 3727",
    accounts: "الحسابات",
    createAccount: "إنشاء حساب",
    createAccountDesc: "حساب مكتب جديد مع فترة اشتراك",
    deleteUser: "حذف الحساب",
    confirmDeleteUser: "سيتم حذف حساب المكتب وكل سياراته وسجلاته.",
    deletedUser: "تم حذف الحساب",
    accountCreated: "تم إنشاء الحساب",
    periodExtended: "تم تمديد الاشتراك",
    passwordUpdated: "تم تحديث كلمة المرور",
    periodValue: "المدة",
    periodUnit: "الوحدة",
    months: "شهور",
    years: "سنوات",
    role: "الدور",
    roleAdmin: "مسؤول",
    roleOffice: "مكتب",
    expires: "ينتهي",
    noExpiry: "بدون انتهاء",
    expired: "منتهي",
    daysLeft: "يوماً متبقياً",
    statusCol: "الحالة",
    disable: "تعطيل",
    enable: "تفعيل",
    disabled: "معطّل",
    extendPeriod: "تمديد الاشتراك",
    lastOilDate: "تاريخ آخر تبديل زيت",
    gpsSection: "تتبع GPS",
    gpsDeviceId: "رقم جهاز MadarTech",
    gpsDeviceHint: "أدخل معرّف الجهاز من حسابك في MadarTech",
    gpsSync: "مزامنة GPS الآن",
    gpsSyncing: "جاري المزامنة…",
    gpsSynced: "تمت مزامنة GPS",
    gpsSyncFailed: "فشلت مزامنة GPS",
    gpsNotConfigured: "لم تُضبط بيانات ربط MadarTech على الخادم بعد",
    gpsNoDevice: "لم يُربط جهاز GPS بهذه السيارة",
    gpsLastSync: "آخر مزامنة",
    gpsPosition: "الموقع الحالي",
    gpsOdometer: "قراءة GPS",
    viewOnMap: "عرض على الخريطة",
    emailLabel: "البريد الإلكتروني",
    emailHint: "يُرسَل الملخّص اليومي في الساعة 23:55 بتوقيت عُمان",
    emailCol: "البريد",
    settings: "الإعدادات",
    filterByCar: "تصفية حسب السيارة",
    tripHistory: "سجل الإرجاعات",
    noTrips: "لا توجد إرجاعات مسجلة بعد.",
    firstTimeCta: "أضف أول سيارة لتبدأ التتبع.",
    close: "إغلاق",
    settingsPage: "الإعدادات",
    officeSection: "هوية مكتب التأجير",
    officeName: "اسم المكتب",
    officeNameHint: "يظهر في الشريط الجانبي والتقارير",
    officeLogo: "شعار المكتب",
    uploadLogo: "رفع الشعار",
    removeLogo: "حذف الشعار",
    logoHint: "صورة مربعة PNG أو JPG بحجم أقل من 500 كيلوبايت",
    themeSection: "لون الواجهة",
    themeDesc: "اختر اللون المميز الذي يظهر على الأزرار الرئيسية والروابط ومؤشرات الحالة.",
    themeColor: "اللون المفضل",
    presetColors: "ألوان مقترحة",
    resetTheme: "استعادة اللون الافتراضي",
    savedSettings: "تم حفظ الإعدادات",
    logoTooLarge: "الصورة كبيرة جداً. الحد الأقصى 500 كيلوبايت.",
    footerRights: "جميع الحقوق محفوظة للمهندس سلطان عبدالعزيز أبوذيبة",
  },
};
